type StorageName = 'localStorage' | 'sessionStorage';

export const readStored = (storage: StorageName, key: string): unknown => {
    try {
        return JSON.parse(globalThis[storage].getItem(key) ?? 'null');
    } catch {
        return null;
    }
};

export const writeStored = (storage: StorageName, key: string, value: unknown): void => {
    try {
        globalThis[storage].setItem(key, JSON.stringify(value));
    } catch {
        // Storage unavailable (private mode, quota): the rail keeps its defaults.
    }
};
